// User preferences (device-local). Small, synchronous reads; persisted in the background.
import { useSyncExternalStore } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';

export type ThemePref = 'dark' | 'light' | 'system';
export type Prefs = {
  archiveDays: number;   // 0 = never auto-archive
  humanBadge: boolean;   // show an "H" badge on people (bots always get a "B")
  theme: ThemePref;      // Settings → Appearance
  scope: string;         // which workspace the room list shows: 'all', or a workspace's id
};
const KEY = 'helm_prefs_v1';
const DEFAULTS: Prefs = { archiveDays: 7, humanBadge: false, theme: 'dark', scope: 'all' };
let prefs: Prefs = DEFAULTS;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export async function loadPrefs(): Promise<void> {
  try { const raw = await AsyncStorage.getItem(KEY); if (raw) prefs = { ...DEFAULTS, ...JSON.parse(raw) }; } catch { /* keep defaults */ }
  emit();
}
export function setPrefs(patch: Partial<Prefs>): void {
  prefs = { ...prefs, ...patch }; emit();
  AsyncStorage.setItem(KEY, JSON.stringify(prefs)).catch(() => {});
}
export const getPrefs = () => prefs;
export function usePrefs(): Prefs {
  return useSyncExternalStore((cb) => { listeners.add(cb); return () => { listeners.delete(cb); }; }, () => prefs);
}
